export const TOAST_MESSAGES = {
  SIGN_UP_SUCCESS: "Sign up successfull. Please Login!",
  SIGN_UP_FAILURE: "User already exist , Kindly Login !",
  LOGIN_SUCCESS: "Login successfull",
  LOGIN_FAILURE: "Incorrect email or password",
  INVALID_EMAIL: "Invalid email",
  EMAIL_VALIDATION: "Incorrect Email , must follow @gmail.com",
  PASSWORD_VALIDATION: "Password must be at least 6 characters",
  REQUIRED: "Required",
  SOMETHING_WENT_WRONG: "Something went Wrong",
  FIRST_NAME_VALIDATION: "First name must contain only letters",
  LAST_NAME_VALIDATION: "Last name must contain only letters",
  SESSION_TIMEOUT: "Session Expired",
  USER_UPDATED: "User updated successfully",
  USER_UPDATION_FAILED: "User updation failed",
  USER_UPDATION_ERROR: "Error updating user",
  ERROR_FETCHING_USERS: "Error fetching users",
  NO_USER_DATA: "Users Data Not Available",
  USER_DATA_FETCH: "Users data fetched successfully!",
  USER_DATA_ERROR: "Failed to fetch user data!",
  NO_USER_SELECTION: "No users selected",
  BULK_UPDATION_SUCCESS: "Users updated successfully",
  BULK_UPDATION_FAILURE: "Bulk update failed!",
  HANDLE_BULK_UPDATE: "Select at least Role or Status to update",
  LOGGED_IN_USER_FETCH_FAILED: "Failed to fetch logged-in user",
  NO_VALID_SELECTED_USER_BULK_UPDATE: "No valid users selected for bulk update",
  FAIL_TO_FETCH_FILE: "Fail to fetch files"
};

export const ROLES = {
  MANAGING_DIRECTOR: "MANAGING_DIRECTOR",
  HEAD_OFFICE: "HEAD_OFFICE",
  GOVERNMENT_OFFICER: "GOVERNMENT_OFFICER",
  INVENTORY_INCHARGE: "INVENTORY_INCHARGE",
  INVENTORY_ADMIN: "INVENTORY_ADMIN", 
  PROJECT_MANAGER: "PROJECT_MANAGER",
  PROJECT_ENGINEER: "PROJECT_ENGINEER",
  SITE_ENGINEER: "SITE_ENGINEER",
  PROCUREMENT_INCHARGE: "PROCUREMENT_INCHARGE",
  BILLING_INCHARGE: "BILLING_INCHARGE",
  INVENTORY_INCHARGE: "INVENTORY_INCHARGE",
  INVENTORY_ADMIN: "INVENTORY_ADMIN",
};

export const ROLES_LABELS = {
  MANAGING_DIRECTOR: "Managing Director",
  HEAD_OFFICE: "Head Office",
  GOVERNMENT_OFFICER: "Government Officer",
  INVENTORY_INCHARGE: "Inventory Incharge",
  INVENTORY_ADMIN:  "Inventory Admin",
  PROJECT_MANAGER: "Project Manager",
  PROJECT_ENGINEER: "Project Engineer",
  SITE_ENGINEER: "Site Engineer",
  PROCUREMENT_INCHARGE: "Procurement Incharge",
  BILLING_INCHARGE: "Billing Incharge",
  INVENTORY_INCHARGE: "INVENTORY_INCHARGE",
  INVENTORY_ADMIN: "INVENTORY_ADMIN",
};


export const ASC = "asc";
export const DESC = "desc";
export const NO_DATA_AVAILABLE = "No data available!";

export const ROLE = {
  ALL: { value: "ALL", label: "All" },
  MANAGING_DIRECTOR: { value: "MANAGING_DIRECTOR", label: "Managing Director" },
  HEAD_OFFICE: { value: "HEAD_OFFICE", label: "Head Office" },
  GOVERNMENT_OFFICER: { value: "GOVERNMENT_OFFICER", label: "Government Officer" },
  INVENTORY_INCHARGE:{ value: "INVENTORY_INCHARGE", label: "Inventory Incharge" },
  INVENTORY_ADMIN: { value: "INVENTORY_ADMIN", label: "Inventory Admin"},
  PROJECT_MANAGER: { value: "PROJECT_MANAGER", label: "Project Manager" },
  PROJECT_ENGINEER: { value: "PROJECT_ENGINEER", label: "Project Engineer" },
  SITE_ENGINEER: { value: "SITE_ENGINEER", label: "Site Engineer" },
  PROCUREMENT_INCHARGE: { value: "PROCUREMENT_INCHARGE", label: "Procurement Incharge"},
  BILLING_INCHARGE: { value: "BILLING_INCHARGE", label: "Billing Incharge"},
  INVENTORY_INCHARGE: { value:"INVENTORY_INCHARGE", label: "Inventory Incharge"},
  INVENTORY_ADMIN: { value: "INVENTORY_ADMIN", label: "Inventory Admin"}
};

export const STATUS_LABELS = {
  PENDING: "Pending",
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  ALL: "All",
};

export const RESET_PAGINATION = {
  count: 0,
  offset: 0,
  limit: 15,
};

export const GET_ALL_PAGINATION = {
  count: 0,
  offset: 0,
  limit: 1000,
};

export const PRIORITY_OPTIONS = [
  { value: "LOW", label: "Low" },
  { value: "MEDIUM", label: "Medium" },
  { value: "HIGH", label: "High" },
];

export const getPriorityStatusColor = (priority) => {
  switch (priority) {
    case "LOW":
      return "bg-green-50 text-green-600 transition-colors";
    case "MEDIUM":
      return "bg-yellow-50 text-yellow-600 transition-colors";
    case "HIGH":
      return "bg-red-50 text-red-600 transition-colors";
    default:
      return "bg-gray-50 text-gray-600 transition-colors"; // fallback for unknown priority
  }
};

